export const ACTION_EVENT_PUBLISHED = 'EventPublished';
export const ACTION_EVENT_UPDATED = 'EventUpdated';
export const ACTION_EVENT_UNPUBLISHED = 'EventUnpublished';
export const ACTION_BANK_ACCOUNT_ADDED = 'BankAccountAdded';
export const ACTION_PAYOUT_METHOD_ACCEPTED_FOR_EVENT =
    'PayoutMethodAcceptedForEvent';

export const TIME_AGO_UNITS = {
    JUST_NOW: 'Just now',
    MINUTE: 'minute',
    MINUTES: 'minutes',
    HOUR: 'hour',
    HOURS: 'hours',
    DAY: 'day',
    DAYS: 'days',
    SUFFIX: 'ago',
};

// Time unit constants (in seconds)
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
export const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;
